u_ConvertStringToHTML = (str) => {
  let parser = new DOMParser();
  let doc = parser.parseFromString(str, 'text/html');
  return doc.body;
}
u_ConvertStringToJS = (str) => {
  var script = document.createElement("script");
  script.text = str;
  document.head.appendChild(script).parentNode.removeChild(script);
}
u_FormatMoney = (cents, money_format) => {
  money_format = money_format || Theme.moneyFormat;
  return {
    money: Shopify.formatMoney(cents, money_format),
    money_with_currency: Shopify.formatMoney(cents, money_format),
  }
}
u_AddItemsToCart = async (items_to_add) => {
  // items_to_add = [{
  //   quantity: qty,
  //   id: variant_id,
  //   selling_plan: selling_plan_id,
  //   properties: {}
  // }]
  return await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: items_to_add })
  })
}

u_UpdateCartItems = async(updates) => {
  return await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  }).then(res => res.json());
}
  
u_UpdateCartItem = async (item) => {
  if (!item) return;

  return await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(item),
  });
}
u_GetCart = async () => {
  return await fetch('/cart.js').then(res => res.json());
}
u_ObserveCartRequests = () => {
  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if (entry.name.indexOf('/cart/') !== -1) {
        // console.log(entry)
        document.dispatchEvent(new CustomEvent('cart:modified', {detail: {entry}}));
      }
    }
  });
  
  observer.observe({
    entryTypes: ["resource"]
  });    
}
u_ObserveMutation = (selector, options, callback) => {
  let observer = new MutationObserver(callback);

  // Notify me of everything!
  let observerConfig = {
    attributes: true, 
    childList: true, 
    characterData: true 
  };
  observerConfig = Object.assign(observerConfig, options);

  // Node, config
  // In this case we'll listen to all changes to body and child nodes
  var targetNodes = document.querySelectorAll(selector);
  targetNodes.forEach((node) => {
    observer.observe(node, observerConfig);
  });  
}
u_FormSubmitAjax = async(form) => {
  return await fetch(form.action, { method: 'POST', body: new FormData(form) });
}
u_Convert2JSON = (json) => {
  return JSON.parse(JSON.stringify(json));
}
const u_AddWeekDays = (startDate, count) => Array.from({ length: count }).reduce((date) => {
  date = new Date(date.setDate(date.getDate() + 1));
  if (date.getDay() % 6 === 0)
    date = new Date(date.setDate(date.getDate() + (date.getDay() / 6 + 1)));
  return date;
}, startDate)
const u_FormatDate = (date) => {
  date = date || new Date();
  const formatter = new Intl.DateTimeFormat('en-US', { day: '2-digit', month: 'short' });
  return formatter.format(date);
}
const u_OnElementLoad = (selector, callback) => {
  let count = 0
  var t = setInterval(function() {
    var element = document.querySelector(selector);
    count += 100;
    if (
      (element !== null && element !== undefined) || 
      count > 100 * 10 * 3
    ) {
      clearInterval(t);
      callback(element);
    }
  }, 100);
}